module.exports = __webpack_public_path__ + "static/img/40.75d86111.png";